export default "__VITE_ASSET__BPS6$ty6__"